import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Mousewheel,Pagination, Navigation } from "swiper";
import { MoonLoader } from 'react-spinners';

function SeriesDetails(props) {
    let { id } = useParams();

    let [seriesDetails, setSeriesDetails] = useState({});
    let [seriesVideos,setSeriesVideos] = useState({});
    let [seriesCast,setSeriesCast] = useState(null);


    async function getSeriesDetails() {
        let { data } = await axios.get(`https://api.themoviedb.org/3/tv/${id}?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        setSeriesDetails(data);
    }
    async function getVideos(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/tv/${id}/videos?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        let seriesVideos = data.results;
        let seriesTrailer = seriesVideos.filter(elem => elem.type == "Trailer");
        setSeriesVideos(seriesTrailer[0].key);
       
    }
    async function getSeriesCast(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/tv/${id}/credits?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        setSeriesCast(data.cast.filter(elem => elem.profile_path != null));
    }
    async function up(){
        window.scrollTo(0,0);
     } 
    useEffect(() => {
        getSeriesDetails();
        getSeriesCast();
        getVideos();
        up()
    }, [])
    return <>
        {seriesVideos && seriesCast ? <><div className="container p-4">
            <div className="row">
                <div className="col-md-4">
                    <div>
                        <img className='w-100 rounded-3' src={`https://image.tmdb.org/t/p/w500/${seriesDetails.poster_path}`} alt="series info" />
                    </div>
                </div>
                <div className="col-md-8">
                    <div>
                        <h2>{seriesDetails.name}</h2>
                        <p className='text-muted'>{seriesDetails.tagline}</p>
                        <div className='row gy-1 align-items-center'>
                        {seriesDetails.genres?.map((genre, idx) => <div key={idx} className='col-md-3'>
                            <div className='bg-info p-2 rounded-5 text-center text-white'>{genre.name}</div>
                        </div>)}
                        </div>
                        <div className='mt-2'><iframe className='mt-2 rounded-2 w-100' height="450" src={`https://www.youtube.com/embed/${seriesVideos}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></div>
                        <h4 className='my-5'>Vote : {seriesDetails.vote_average}</h4>
                        <h4 className='my-5'>Vote Count : {seriesDetails.vote_count}</h4>
                        <h4 className='my-5'>Popularity : {seriesDetails.popularity}</h4>
                        {seriesCast.length !=0? <div className='my-3 row'>
                        <h4>Cast:</h4>
                        <Swiper
        slidesPerView={4}
        spaceBetween={15}
        slidesPerGroup={4}
        loop={false}
        loopFillGroupWithBlank={true}
        mousewheel={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Mousewheel, Navigation]}
        className="mySwiper"
      >
        {seriesCast?.map((cast,idx) => <SwiperSlide key={idx}><div className="col-12 my-2 mx-2 rounded-3">
                            <Link to={`/peopledetails/${cast.id}`}>
                            <figure>
                                <img className='w-100 rounded-2' src={`https://image.tmdb.org/t/p/w500${cast.profile_path}`} alt="actor" />
                                <figcaption className='pt-2'>
                                    <h6>{cast.name}</h6>
                                    <h6>{cast.character}</h6>
                                </figcaption>
                            </figure>
                            </Link>
                            </div></SwiperSlide>)}
      </Swiper>
                        
                    </div> : ""}
                        <div className='my-3 row'><h4 >Production Companies :</h4>
                            {seriesDetails.production_companies?.map((procomp, idx) => <div key={idx} className="col-2 mx-2 d-flex justify-content-center align-items-center">{procomp.logo_path !== null ? <><div>
                                <img className='w-100 rounded-2 my-4' src={`https://image.tmdb.org/t/p/w500${procomp.logo_path}`} alt="production company" />
                            </div></> : <div key={idx}><h6 style={{ "fontFamily": "Cairo" }}>{procomp.name}</h6></div>}
                            </div>
                            )}</div>

                        <p className='text-muted'>{seriesDetails.overview}</p>
                    </div>
                </div>
            </div>
        </div></> : <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}

    </>
}

export default SeriesDetails;